// assets/cart-progress.js
(function () {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const CART_JS_URL     = root + 'cart.js';
  const CART_ADD_URL    = (window.routes && window.routes.cart_add_url)    || (root + 'cart/add.js');
  const CART_CHANGE_URL = (window.routes && window.routes.cart_change_url) || (root + 'cart/change.js');

  class CartProgress {
    constructor() {
      // DOM-Refs (defensiv)
      this.progressBar     = document.querySelector('.progress-fill');
      this.progressMessage = document.querySelector('.progress-message');
      this.progressSteps   = document.querySelectorAll('.progress-step');

      // Thresholds & Voucher
      this.voucherId         = '54059128226060'; // Variant-ID als String
      this.shippingThreshold = 70;  // €
      this.giftThreshold     = 100; // €

      // Event-Subscription (optional)
      if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (!event || !event.cartData) return;
          this.updateProgress(event.cartData).catch(console.warn);
        });
      }

      // Initialer Zustand
      const initial = window.cartData;
      if (initial && typeof initial.total_price === 'number') {
        this.updateProgress(initial).catch(console.warn);
      } else {
        // Self-heal: Cart laden
        this.fetchCart()
          .then((cart) => this.updateProgress(cart))
          .catch((err) => console.warn('[CartProgress] initial fetch failed', err));
      }
    }

    async fetchCart() {
      const res = await fetch(CART_JS_URL, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('cart.js fetch failed');
      return res.json();
    }

    /** Safely reads total in EUR and items[] */
    normalizeCart(cartData) {
      const cart = cartData && typeof cartData === 'object' ? cartData : {};
      const total_cents = typeof cart.total_price === 'number' ? cart.total_price : 0;
      const items = Array.isArray(cart.items) ? cart.items : [];
      return { total_eur: total_cents / 100, items, raw: cart };
    }

    async updateProgress(cartData) {
      const { total_eur, items, raw } = this.normalizeCart(cartData);

      // DOM guards: falls Markup fehlt, beenden ohne Crash
      if (!this.progressBar || !this.progressMessage) return;

      const percent = Math.min((total_eur / this.giftThreshold) * 100, 100);
      this.progressBar.style.width = `${percent}%`;

      if (total_eur >= this.giftThreshold) {
        this.progressMessage.textContent = 'Glückwunsch! Sie haben alle Vorteile freigeschaltet!';
        this.progressMessage.style.color = '#4CAF50';
        await this.ensureVoucherInCart(items);
      } else if (total_eur >= this.shippingThreshold) {
        this.progressMessage.textContent = `Kostenloser Versand freigeschaltet! Noch ${(this.giftThreshold - total_eur).toFixed(2)}€ bis zum Geschenk-Gutschein!`;
        this.progressMessage.style.color = '#4CAF50';
        await this.removeVoucherIfPresent(items);
      } else {
        this.progressMessage.textContent = `Noch ${(this.shippingThreshold - total_eur).toFixed(2)}€ bis zum kostenlosen Versand!`;
        this.progressMessage.style.color = '#000';
        await this.removeVoucherIfPresent(items);
      }

      // Steps updaten (defensiv)
      this.progressSteps.forEach((step) => {
        const stepAmount = parseFloat(step.dataset.amount || '0');
        if (total_eur >= stepAmount) step.classList.add('achieved');
        else step.classList.remove('achieved');
      });

      // window.cartData aktualisieren (optional, für andere Skripte)
      window.cartData = raw;
    }

    findVoucher(items) {
      const vid = String(this.voucherId);
      // viele Themes: items[].id = Variant-ID; andere: items[].variant_id
      return items.find((it) => String(it.variant_id || it.id) === vid);
    }

    async ensureVoucherInCart(items) {
      if (this.findVoucher(items)) return;
      await this.addVoucherToCart();
    }

    async removeVoucherIfPresent(items) {
      const voucherItem = this.findVoucher(items);
      if (!voucherItem) return;
      await this.removeVoucherFromCart(voucherItem);
    }

    async addVoucherToCart() {
      try {
        const payload = { items: [{ id: this.voucherId, quantity: 1 }] };
        const res = await fetch(CART_ADD_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(payload),
        });
        if (!res.ok) throw new Error('add failed');
        const cart = await res.json();

        // Event feuern, falls vorhanden
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-progress', cartData: cart });
        } else {
          // sonst selbst weiter verarbeiten
          await this.updateProgress(cart);
        }
      } catch (e) {
        console.warn('[CartProgress] add voucher error', e);
      }
    }

    async removeVoucherFromCart(voucherItem) {
      try {
        // Shopify /cart/change.js akzeptiert 'line' ODER 'id' (line item key).
        // Key ist stabiler, falls verfügbar:
        const bodyObj = voucherItem.key
          ? { id: voucherItem.key, quantity: 0 }
          : (typeof voucherItem.line === 'number'
              ? { line: voucherItem.line, quantity: 0 }
              : { id: voucherItem.id, quantity: 0 } // Fallback
            );

        // Abschnitte nur mitsenden, wenn Helper existiert
        if (typeof window.getSectionsToRender === 'function') {
          bodyObj.sections = getSectionsToRender().map((s) => s.section);
          bodyObj.sections_url = window.location.pathname;
        }

        const res = await fetch(CART_CHANGE_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(bodyObj),
        });
        if (!res.ok) throw new Error('change failed');
        const cart = await res.json();

        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-progress', cartData: cart });
        } else {
          await this.updateProgress(cart);
        }
      } catch (e) {
        console.warn('[CartProgress] remove voucher error', e);
      }
    }
  }

  // Bootstrap
  window.addEventListener('DOMContentLoaded', function () {
    try { new CartProgress(); } catch (e) { console.warn('[CartProgress] init error', e); }
  });
})();
